import {
  CLEAR_SESI,
  GET_ALL_BADGES_REQUEST,
  GET_ALL_NOTIFICATION_REQUEST,
  GET_ALL_PESAN_REQUEST,
  GET_MORE_NOTIFICATION_REQUEST,
  GET_MORE_PESAN_REQUEST,
  GET_PROFILE_REQUEST,
  READS_NOTIFICATION_REQUEST,
  READS_PESAN_REQUEST,
  SIGNIN_USER_REQUEST,
  UPDATE_PROFILE_REQUEST,
} from '@/store/types';
import { takeEvery, takeLatest } from 'redux-saga/effects';
import {
  clearSesiHandler,
  getProfileDetailHandler,
  signInUserHandler,
  updateProfileHandler,
} from '@/store/saga/handlers/sesi';
import {
  getAllNotificationHandler,
  getMoreNotificationHandler,
  readsAllNotificationHandler,
} from './handlers/notifikasi';
import { getAllBadgesHandler } from './handlers/badge';
import {
  getAllPesanHandler,
  getMorePesanHandler,
  readsAllPesanHandler,
} from './handlers/pesan';

export default function* rootSaga() {
  yield takeLatest(SIGNIN_USER_REQUEST, signInUserHandler);
  yield takeLatest(UPDATE_PROFILE_REQUEST, updateProfileHandler);
  yield takeLatest(GET_PROFILE_REQUEST, getProfileDetailHandler);
  yield takeLatest(GET_ALL_BADGES_REQUEST, getAllBadgesHandler);
  yield takeLatest(GET_ALL_NOTIFICATION_REQUEST, getAllNotificationHandler);
  yield takeLatest(GET_ALL_PESAN_REQUEST, getAllPesanHandler);
  yield takeLatest(GET_MORE_NOTIFICATION_REQUEST, getMoreNotificationHandler);
  yield takeLatest(GET_MORE_PESAN_REQUEST, getMorePesanHandler);
  yield takeLatest(READS_NOTIFICATION_REQUEST, readsAllNotificationHandler);
  yield takeLatest(READS_PESAN_REQUEST, readsAllPesanHandler);
  yield takeEvery(CLEAR_SESI, clearSesiHandler);
}
